import { config } from './config';
import { EncodeQueryData } from '../helpers/miscHelpers';
import { deleteCookie } from '../helpers/PhoneNumberHelper';
import { TRF_TYPES } from '../components/TrfScreens/trfHelpers';

const TRF_ACCESS_TOKEN_KEY = 'access_token';

export function getTrfAccessToken() {
  return localStorage.getItem(TRF_ACCESS_TOKEN_KEY);
}

export function setTrfAccessToken(token) {
  localStorage.setItem(TRF_ACCESS_TOKEN_KEY, token);
}

export function clearTrfAccessToken() {
  localStorage.removeItem(TRF_ACCESS_TOKEN_KEY);
}

export function logoutTrfSession() {
  localStorage.clear();
  deleteCookie('auth_enabled');
  window.location.assign('/login');
}

function trfAuthHeaders() {
  const accessToken = getTrfAccessToken();
  if (!accessToken) {
    logoutTrfSession();
    throw new Error('Missing access token');
  }
  return new Headers({
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  });
}

async function parseTrfResponse(res) {
  if (res.status === 401) {
    logoutTrfSession();
    throw Error(res.status);
  }
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function SchedulerVerifyMedic(number) {
  const headers = new Headers({
    Accept: 'application/json',
    'Content-Type': 'application/json',
  });
  const res = await fetch(`${config().apiHost}/v1/scheduler/emedic?mobile_number=${number}`, {
    method: 'GET',
    headers,
  });
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function SendOtp(number) {
  const headers = new Headers({
    'Content-Type': 'application/json',
  });
  const res = await fetch(`${config().apiHost}/v1/accounts/otp/generate`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      mobile_number: number,
    }),
  });
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function VerifyOtp(number, otp_input) {
  const headers = new Headers({
    'Content-Type': 'application/json',
  });
  const res = await fetch(`${config().apiHost}/v1/accounts/otp/validate`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      mobile_number: number,
      otp: otp_input,
    }),
  });
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}

export async function GetPartnersFromPartnerWrapper(params) {
  const queryParamsUrl = EncodeQueryData(params);
  const headers = trfAuthHeaders();
  const res = await fetch(`${config().apiHost}/v1/partner?${queryParamsUrl}`, {
    method: 'GET',
    headers,
  });
  return parseTrfResponse(res);
}

export async function GetRetails(params) {
  const queryParamsUrl = EncodeQueryData(params);
  const headers = trfAuthHeaders();
  const res = await fetch(`${config().apiHost}/v1/trf/retails?${queryParamsUrl}`, {
    method: 'GET',
    headers,
  });
  return parseTrfResponse(res);
}

export async function PostCollection(partner_id, partner_name, partnerType = 'in_clinic') {
  const isRetail = partnerType === 'retail';
  const headers = trfAuthHeaders();
  const res = await fetch(`${config().apiHost}/collection_request`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      entity_type: isRetail ? 'occ' : 'partner',
      partner_id: Number(partner_id),
      doctor_name: partner_name,
      clinic_address: '',
    }),
  });
  return parseTrfResponse(res);
}

export async function PostTrf(id, type, collectionId, riderNumber, riderId) {
  const headers = trfAuthHeaders();
  const res = await fetch(`${config().apiHost}/collection_request/${id}/collection?runner_number=${riderNumber}&runner_id=${riderId}`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      type,
      id: collectionId,
    }),
  });
  return parseTrfResponse(res);
}

export async function PatchTrf(collId, trfId, barcode, trfUrlsArray, packetUrlsArray) {
  const headers = trfAuthHeaders();
  let riderNumber;
  let riderId;
  const riderDetails = localStorage.getItem('rider_body');
  if (riderDetails) {
    const parsedDetails = JSON.parse(riderDetails);
    if (parsedDetails && parsedDetails.result) {
      riderNumber = parsedDetails.result.mobile_number;
      riderId = parsedDetails.result.id;
    }
  }
  const res = await fetch(`${config().apiHost}/collection_request/${collId}/collection/${trfId}?runner_number=${riderNumber}&runner_id=${riderId}`, {
    method: 'PATCH',
    headers,
    body: JSON.stringify({
      packet_id: barcode,
      trf_images: trfUrlsArray,
      packet_images: packetUrlsArray,
    }),
  });
  return parseTrfResponse(res);
}

export async function DeleteTrf(collId, trfId) {
  const headers = trfAuthHeaders();
  const res = await fetch(`${config().apiHost}/collection_request/${collId}/collection/${trfId}`, {
    method: 'DELETE',
    headers,
  });
  return parseTrfResponse(res);
}

export async function SubmitTrf(cityCode, collReq) {
  const recollections = collReq?.collections.filter(
    item => item?.type === 'RECOLLECTION'
    && item?.packet_id !== ''
    && item?.packet_images !== null
    && item?.trf_images !== null,
  );
  const digitalCollections = collReq?.collections.filter(
    item => item?.type === TRF_TYPES.DIGITAL_TRF
    && item?.packet_id !== ''
    && item?.packet_images !== null,
  );
  const digitalCollectionsIds = digitalCollections?.map(obj => obj?.id);
  const recollectionArray = recollections.map(obj => obj.id);
  const regularCollections = collReq?.collections.filter(
    item => item?.type === 'REGULAR COLLECTION',
  );
  const headers = trfAuthHeaders();
  const results = [];
  async function Regular() {
    const res = await fetch(`${config().apiHost}/v1/oms/collection-request/sync`, {
      method: 'POST',
      body: JSON.stringify({
        collectionRequestId: collReq?.id,
        cityCode,
      }),
      headers,
    });
    results.push(res);
    return parseTrfResponse(res);
  }
  async function Recollection() {
    const res = await fetch(`${config().apiHost}/v1/oms/recollections/sync`, {
      method: 'POST',
      body: JSON.stringify({
        collectionRequestId: collReq?.id,
        recollectionIds: recollectionArray,
        cityCode,
      }),
      headers,
    });
    return parseTrfResponse(res);
  }
  async function DigitalCollection() {
    const res = await fetch(`${config().apiHost}/v1/oms/collection/digital-trf/sync`, {
      method: 'POST',
      body: JSON.stringify({
        collectionRequestId: collReq?.id,
        collectionIds: digitalCollectionsIds,
        cityCode,
      }),
      headers,
    });
    return parseTrfResponse(res);
  }

  if (regularCollections.length > 0) {
    results.push(Regular());
  }
  if (recollections.length > 0) {
    results.push(Recollection());
  }
  if (digitalCollections.length > 0) {
    results.push(DigitalCollection());
  }
  await Promise.all(results);
}
